import { render, staticRenderFns } from "./singleDetail.vue?vue&type=template&id=3e7561cc&scoped=true&"
import script from "./singleDetail.vue?vue&type=script&lang=js&"
export * from "./singleDetail.vue?vue&type=script&lang=js&"
import style0 from "./singleDetail.vue?vue&type=style&index=0&id=3e7561cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7561cc",
  null
  
)

export default component.exports